import { Component, OnInit } from '@angular/core';
import { DETALLE_BANK } from 'src/app/services/constant-services.data';
import { GlobalService } from 'src/app/services/global/global.service';

@Component({
  selector: 'app-bank-data',
  templateUrl: './bank-data.component.html',
  styleUrls: ['./bank-data.component.scss']
})
export class BankDataComponent implements OnInit {
  bank:any;
  constructor(
    public globalService: GlobalService
  ) { }

  ngOnInit() {
    this.bank = DETALLE_BANK
  }

}
